import { isOneOf } from './isOneOf';

export const isNotOneOf = ({
  questionToCheck,
  comparisonOperands,
}: Parameters<typeof isOneOf>[0]): boolean =>
  !isOneOf({ questionToCheck, comparisonOperands });
